import Vue from 'vue'
import $glAuth from '@/services/$glAuth'

/*
  how to use:
    v-gl-superadmin-only="true"
*/
Vue.directive('gl-superadmin-only', {
  // on insert
  inserted (el, binding, vnode) {
    // if not super admin -> remove element
    if (!$glAuth.isSuperAdmin()) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/gl-superadmin-only.js